import React from 'react';

/**
 * Cell renderer for totals row in DataGrid
 * 
 * @param {Object} props
 * @param {string} props.headerText - The header text to lookup in totalsRow
 * @param {Object} props.totalsRow - Hash mapping of header text to display value
 * @param {Object} props.style - Optional additional styles
 * @returns {JSX.Element}
 */
export function TotalsCell(_ref) {
  let {
    headerText,
    totalsRow,
    style = {}
  } = _ref;
  const value = totalsRow?.[headerText] ?? '';
  return /*#__PURE__*/React.createElement("div", {
    className: "DataGridTable-totals-cell",
    style: {
      fontWeight: 'bold',
      textAlign: 'right',
      padding: '4px 8px',
      ...style
    }
  }, value || '-');
}